import { DatePipe } from '@angular/common';
import { Component, OnInit, EventEmitter, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import * as $ from 'jquery';
import { Subject } from "rxjs";
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { DateObject, GM_APP } from 'src/app/models/common';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { CommonService } from 'src/app/services/common.service';
import { GrantsSummaryService } from "src/app/services/grants/grants-summary.service";
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, tap } from 'rxjs';
import { HeadService } from 'src/app/services/common/headservice';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import { Router } from '@angular/router';
import { IDeactivateComponent } from 'src/app/services/common/deactivate-guard.service';



@Component({
  selector: 'app-grants-delivery-format',
  templateUrl: './grants-delivery-format.component.html',
  styleUrls: ['./grants-delivery-format.component.scss']
})
export class GrantsDeliveryFormatComponent implements OnInit,IDeactivateComponent {
  formFields;
  stateOptions = [];
  staticformFields: any;
  currentFormattype: any;
  countryOptions = [];
  therapeuticAreaOptions:any = []
  MeetingOptions = [];
  deliveryFormatForm: UntypedFormGroup;
  deliveryFormatOptions: any = [];
  content: any;
  therapeuticAreas$: Observable<any>;
  heading: string;
  minDate : Date = new Date();
  ReleaseDate = new Date();
  ExpiryDate = new Date();
  StartDate = new Date();
  EndDate = new Date();
  WebStartDate = new Date();
  WebEndDate = new Date();
  action: Subject<any> = new Subject();
  grantsapp: GM_APP;
  permission: string;
  ApplicationID: any;
  maxReleaseDate: Date | undefined;
  minReleaseDate = new Date();
  maxExpiryDate: Date | undefined;
  minExpiryDate = new Date();
  minstartDate = new Date();
  maxStartDate: Date | undefined;
  minEndDate = new Date();
  maxEndDate: Date | undefined;
  appid: string;
  IsOptProcessOptions: any = [];
  operations: any = [];
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;

  constructor(
    private router: Router,
    private summaryService: GrantsSummaryService,
    private appFunctions: AppFunctionsService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private DatashareSerivce: GrantsDatashareService,
    public datepipe: DatePipe,

    private header: HeadService,
    public grantsDatashare: GrantsDatashareService
  ) {
    this.setFormPermissions();
  }
  ngOnInit() {
    this.getStaticFiledsData("SCR-024");     
    this.ApplicationID = this.commonService.appId;
    this.NavigateToGenInfo();
    this.grantsapp = this.commonService.getGrantsApp();
    this.appid = this.commonService.appId;;
    this.DatashareSerivce.GrantApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.deliveryFormatForm = new UntypedFormGroup({
      ID: new UntypedFormControl(null),
      APPLICATION_ID: new UntypedFormControl(null),
      THERAPEUTIC_AREA_ID: new UntypedFormControl("", [Validators.required]),
      FORMAT_TYPE_ID: new UntypedFormControl("", [Validators.required]),
      MEETING_TYPE_ID: new UntypedFormControl(null),
      ENDURING_MATERIAL: new UntypedFormGroup({
        IS_OPT_IN_PROCESS: new UntypedFormControl(null),
        RELEASE_DATE: new UntypedFormControl(null),
        EXPIRY_DATE: new UntypedFormControl(null),
        TRANSFER_MODE: new UntypedFormControl(""),
        RELEASE_DATEOBJ: new UntypedFormControl(null),
        EXPIRY_DATEOBJ: new UntypedFormControl(null)
      }),
      LIVE: new UntypedFormGroup({
        NO_OF_FACULTIES: new UntypedFormControl(""),
        START_DATE: new UntypedFormControl(null),
        END_DATE: new UntypedFormControl(null),
        ADDRESS: new UntypedFormControl(""),
        START_DATEOBJ: new UntypedFormControl(null),
        END_DATEOBJ: new UntypedFormControl(null)

      }),
      WEB: new UntypedFormGroup({
        NO_OF_FACULTIES: new UntypedFormControl(""),
        START_DATE: new UntypedFormControl(null),
        END_DATE: new UntypedFormControl(null),
        START_DATE_STRING: new UntypedFormControl(""),
        END_DATE_STRING: new UntypedFormControl(""),
        WEB_URL: new UntypedFormControl(""),
        START_DATEOBJ: new UntypedFormControl(null),
        END_DATEOBJ: new UntypedFormControl(null)


      }),
    });

    setTimeout(() => { 
      this.setFormPermissions();
      if (this.permission == "view") {
        this.deliveryFormatForm.disable();           
      }
      else 
      {
        this.deliveryFormatForm.enable();
      }
    }, 700);
   // this.getTherapeuticAreaList();

     
    this.fecthdeliveryformat();
   
  }
  private setFormPermissions() {     
    this.permission = this.commonService.getPagePermission("GC03");
    if (this.permission == "view") {
      if (this.extendedForm != null && this.extendedForm != undefined) {
        this.extendedForm.permission = this.permission;
        this.extendedForm.ScreenMode = this.permission;
      }
   //   this.deliveryFormatForm.disable();
    }   
    
      this.deliveryFormatOptions = [
        { value: "", label: "Select" },
        { value: 'enduring_material', label: 'Enduring Material' },
        { value: 'live', label: 'Live' },
        { value: 'web', label: 'Web' }
      ];
    
  if (this.permission == "view") {
   // this.deliveryFormatForm.disable();
    this.operations = [];
  }
  else {
    this.operations = [
      {
        name: 'Save', type: 'submit', callback: this.save, self: this
      }
    ];
  }
  }

  
  onCallbackOperation(opr) {
    opr.callback();
  }

  getSelectedValue(event: any): void {
this.deliveryFormatForm.controls["WEB"].reset();
this.deliveryFormatForm.controls["ENDURING_MATERIAL"].reset();
this.deliveryFormatForm.controls["LIVE"].reset();

  }

  private fecthdeliveryformat() {
    this.summaryService
      .getDeliveryFormatSummary(this.grantsapp.ID)
      .subscribe((result) => {
        if (result != null) {
          this.therapeuticAreaOptions = result.TherapeuticAreaList;
          this.therapeuticAreaOptions = [{ label: "Select", value: null, checked: true }].concat(this.therapeuticAreaOptions);
          if (
            result.ENDURING_MATERIAL == null &&
            result.LIVE == null &&
            result.WEB == null
          ) {
            this.deliveryFormatForm.patchValue({
              ID: result.ID || "",
              APPLICATION_ID: result.APPLICATION_ID || "",
              THERAPEUTIC_AREA_ID: result.THERAPEUTIC_AREA_ID || null,
              FORMAT_TYPE_ID: result.FORMAT_TYPE_ID || null,
              MEETING_TYPE_ID: result.MEETING_TYPE_ID || null,
            });
          } else {
            if (result.ENDURING_MATERIAL != null || result.WEB != null) {
              if (
                result.LIVE != null &&
                (result.LIVE.START_DATE != null &&
                  result.LIVE.START_DATE != "" &&
                  result.LIVE.START_DATE != undefined)
              ) {
                result.LIVE.START_DATE= this.commonService.getdisplayedDate(result.LIVE.START_DATE);
              }
              if (
                result.LIVE.END_DATE != null &&
                result.LIVE.END_DATE != "" &&
                result.LIVE.END_DATE != undefined
              ) {
                result.LIVE.END_DATE = this.commonService.getdisplayedDate(result.LIVE.END_DATE);
              }
              if (
                result.WEB.START_DATE != null &&
                result.WEB.START_DATE != "" &&
                result.WEB.START_DATE != undefined
              ) {
                result.WEB.START_DATE = this.commonService.getdisplayedDate(result.WEB.START_DATE);
              }
              if (
                result.WEB.END_DATE != null &&
                result.WEB.END_DATE != "" &&
                result.WEB.END_DATE != undefined
              ) {
                result.WEB.END_DATE = this.commonService.getdisplayedDate(result.WEB.END_DATE);
              }
              if (
                result.ENDURING_MATERIAL.RELEASE_DATE != null &&
                result.ENDURING_MATERIAL.RELEASE_DATE != "" &&
                result.ENDURING_MATERIAL.RELEASE_DATE != undefined
              ) {
                result.ENDURING_MATERIAL.RELEASE_DATE = this.commonService.getdisplayedDate(result.ENDURING_MATERIAL.RELEASE_DATE);
                
              }
              if (
                result.ENDURING_MATERIAL.EXPIRY_DATE != null &&
                result.ENDURING_MATERIAL.EXPIRY_DATE != ""  &&
                result.ENDURING_MATERIAL.EXPIRY_DATE != undefined
              ) {
                // result.ENDURING_MATERIAL.EXPIRY_DATE = this.datepipe.transform(
                //   result.ENDURING_MATERIAL.EXPIRY_DATE,
                //   'dd-MMM-yyyy'
                // );
                result.ENDURING_MATERIAL.EXPIRY_DATE = this.commonService.getdisplayedDate(result.ENDURING_MATERIAL.EXPIRY_DATE);
      
              }
            }
            this.deliveryFormatForm.patchValue({
              ID: result.ID || "",
              APPLICATION_ID: result.APPLICATION_ID || "",
              THERAPEUTIC_AREA_ID: result.THERAPEUTIC_AREA_ID || null,
              FORMAT_TYPE_ID: result.FORMAT_TYPE_ID || null,
              MEETING_TYPE_ID: result.MEETING_TYPE_ID || null,
              ENDURING_MATERIAL: {
                IS_OPT_IN_PROCESS:
                  result.ENDURING_MATERIAL.IS_OPT_IN_PROCESS || null,
                RELEASE_DATE: result.ENDURING_MATERIAL.RELEASE_DATE || null,
                EXPIRY_DATE: result.ENDURING_MATERIAL.EXPIRY_DATE || null,
                TRANSFER_MODE: result.ENDURING_MATERIAL.TRANSFER_MODE || ""
              },
              LIVE: {
                NO_OF_FACULTIES: result.LIVE.NO_OF_FACULTIES || null,
                START_DATE: result.LIVE.START_DATE || null,
                END_DATE: result.LIVE.END_DATE || null,
                ADDRESS: result.LIVE.ADDRESS || "",

              },
              WEB: {
                NO_OF_FACULTIES: result.WEB.NO_OF_FACULTIES || null,
                START_DATE: result.WEB.START_DATE,
                END_DATE: result.WEB.END_DATE,
                WEB_URL: result.WEB.WEB_URL,
              }

            });
          }
          this.currentFormattype = result.FORMAT_TYPE_ID;
          this.ReleaseDate = new Date(result.ENDURING_MATERIAL.RELEASE_DATE);
          this.ExpiryDate = new Date(result.ENDURING_MATERIAL.EXPIRY_DATE);
          this.StartDate = new Date(result.LIVE.START_DATE);
          this.EndDate = new Date(result.LIVE.END_DATE);
          this.WebEndDate = new Date(result.WEB.END_DATE);
          this.WebStartDate = new Date(result.WEB.START_DATE);
          this.extendedForm.rowid = result.ID;
          this.extendedForm.getResponse();
        }
      });
  }
  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode).subscribe((result) => {
      this.staticformFields = result["Data"];
      this.IsOptProcessOptions =
        this.staticformFields["IS_OPT_IN_PROCESS"].GROUP_VALUES_LIST;
      this.MeetingOptions =
        this.staticformFields["MEETING_TYPE_ID"].GROUP_VALUES_LIST;
      this.MeetingOptions = [{ label: "Select", value: "" }].concat(
        this.MeetingOptions
      );
    });
  }

  //Delivery format type Enduring_Material Date Objects
  Full_Release_Date: DateObject;
  Full_Expiry_Date: DateObject;
  isreleaseDateModified: boolean = false;
  isexpiryDateModified: boolean = false;

  ReleaseDateSelect(event) {
    this.maxReleaseDate = event;
    this.isreleaseDateModified = true;
    this.Full_Release_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isreleaseDateModified,
    };
  }
  ExpiryDateSelect(event) {
    this.maxExpiryDate = event;
    this.isexpiryDateModified = true;
    this.Full_Expiry_Date = {
      Day: event.getDate(),
      Month: event.getMonth() + 1,
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isexpiryDateModified,
    };
  }
  GetReleaseDate(): DateObject {
    var formModel = this.deliveryFormatForm.getRawValue();
    const lDate = new Date(formModel.ENDURING_MATERIAL.RELEASE_DATE);
    if ((
      this.CompareDates(this.ReleaseDate, lDate) ||
      this.Full_Release_Date == null ||
      this.Full_Release_Date == undefined) && formModel.ENDURING_MATERIAL.RELEASE_DATE != null 
    ) {
      this.Full_Release_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 0,
        Minutes: 0,
        Seconds: 0,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false,
      };
    }
    this.Full_Release_Date = {
      Day: lDate.getDate(),
      Month: lDate.getMonth() + 1,
      Year: lDate.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: true,
    };
    return this.Full_Release_Date;
  }
  GetExpiryDate(): DateObject {
    var formModel = this.deliveryFormatForm.getRawValue();
    const lDate = new Date(formModel.ENDURING_MATERIAL.EXPIRY_DATE);
    if ((
      this.CompareDates(this.ExpiryDate, lDate) ||
      this.Full_Expiry_Date == null ||
      this.Full_Expiry_Date == undefined) && formModel.ENDURING_MATERIAL.EXPIRY_DATE != null
    ) {
      this.Full_Expiry_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false,
      };
    }
    else{
      this.Full_Expiry_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: true,
      };
    }
    return this.Full_Expiry_Date;
  }

  //LIVE Date Objects
  Full_Start_Date: DateObject;
  Full_End_Date: DateObject;
  isstartDateModified: boolean = false;
  isendDateModified: boolean = false;

  startDateSelect(event) {
    this.maxStartDate = event;
    this.isstartDateModified = true;
    this.Full_Start_Date = {
      Day: event.getDate(),
      Month: event.getMonth() + 1,
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isstartDateModified,
    };
  }
  EndDateSelect(event) {
    this.maxEndDate = event;
    this.isendDateModified = true;
    this.Full_End_Date = {
      Day: event.getDate(),
      Month: event.getMonth() + 1,
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isendDateModified,
    };
  }
  GetLiveStartDate(): DateObject {
    var formModel = this.deliveryFormatForm.getRawValue();
    const lDate = new Date(formModel.LIVE.START_DATE);
    if ((
      this.CompareDates(this.StartDate, lDate) ||
      this.Full_Start_Date == null ||
      this.Full_Start_Date == undefined) && formModel.LIVE.START_DATE != null
    ) {
      this.Full_Start_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 0,
        Minutes: 0,
        Seconds: 0,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false,
      };
    }
    this.Full_Start_Date = {
      Day: lDate.getDate(),
      Month: lDate.getMonth() + 1,
      Year: lDate.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: true,
    };
    return this.Full_Start_Date;
  }
  GetLiveEndDate(): DateObject {
    var formModel = this.deliveryFormatForm.getRawValue();
    const lDate = new Date(formModel.LIVE.END_DATE);
    if ((
      this.CompareDates(this.EndDate, lDate) ||
      this.Full_End_Date == null ||
      this.Full_End_Date == undefined) && formModel.LIVE.END_DATE != null 
    ) {
      this.Full_End_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false,
      };
    }
    else{
      this.Full_End_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: true,
      };
    }
    return this.Full_End_Date;
  }

  //Deliveryformattype - WEB  Date Objects

  GetWebStartDate(): DateObject {
    var formModel = this.deliveryFormatForm.getRawValue();
    const lDate = new Date(formModel.WEB.START_DATE);
    if ((
      this.CompareDates(this.WebStartDate, lDate) ||
      this.Full_Start_Date == null ||
      this.Full_Start_Date == undefined )&& formModel.WEB.START_DATE != null 
    ) {
      this.Full_Start_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 0,
        Minutes: 0,
        Seconds: 0,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false,
      };
    }
    else{
      this.Full_Start_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 0,
        Minutes: 0,
        Seconds: 0,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: true,
      };
    }
    return this.Full_Start_Date;
  }
  GetWebEndDate(): DateObject {
    var formModel = this.deliveryFormatForm.getRawValue();
    const lDate = new Date(formModel.WEB.END_DATE);
    if ((
      this.CompareDates(this.WebEndDate, lDate) ||
      this.Full_End_Date == null ||
      this.Full_End_Date == undefined)&& formModel.WEB.END_DATE != null
    ) {
      this.Full_End_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false,
      };}
      else{
        this.Full_End_Date = {
          Day: lDate.getDate(),
          Month: lDate.getMonth() + 1,
          Year: lDate.getFullYear(),
          Hours: 23,
          Minutes: 59,
          Seconds: 59,
          IsEndDate: false,
          HasValue: true,
          IsDateModified: true,
        };
    }

    return this.Full_End_Date;
  }

  CompareDates(olddate: any, newDate: any): boolean {
    if (olddate != '' && olddate != undefined && olddate != null) {
      let oDt =
        olddate.getDate().toString() +
        olddate.getMonth().toString() +
        olddate.getFullYear().toString();
      let nDt =
        newDate.getDate().toString() +
        newDate.getMonth().toString() +
        newDate.getFullYear().toString();
      if (oDt == nDt) {
        return true;
      } else {
        return false;
      }
    } else return false;
  }

  getTherapeuticAreaList() {
    this.summaryService
      .getTherapeuticAreaList(this.grantsapp.ID)
      .subscribe((result) => {
        if (result != null) {
          this.therapeuticAreaOptions = result;
          this.therapeuticAreaOptions = [{ label: "Select", value: null, checked: true }].concat(this.therapeuticAreaOptions);
        }
      });
  }   

  postalCodekeyUP(value: string) {
    if (value.length == parseInt("5")) {
      this.commonService.getCity(value).subscribe((x) => {
        if (x.Status) {
          $("#CITY").val(x.Data.City);
          $("#PROVINCE").val(x.Data.StateFullName);
          $("#COUNTRY").val(x.Data.Country);
        }
      });
    } else {
      $("#CITY").val("");
      $("#PROVINCE").val("");
      $("#COUNTRY").val("");
    }
  }

  save() {

    if (this['self'].validateControls()) {
      var formData = this['self'].deliveryFormatForm.value;
      //for insert & update we should pass applicationid
      formData.APPLICATION_ID = this['self'].grantsapp.ID;
      if (
        formData.ID == "" ||
        formData.ID == null ||
        formData.ID == undefined
      ) {
        formData.ID = "";
        //formData.APPLICATION_ID = this['self'].grantsapp.ID;
      }
      if (formData.FORMAT_TYPE_ID != '') {
        if (formData.FORMAT_TYPE_ID == "enduring_material") {

          formData["ENDURING_MATERIAL"]['RELEASE_DATEOBJ'] =
          this['self'].GetReleaseDate();
          formData["ENDURING_MATERIAL"]['EXPIRY_DATEOBJ'] =
          this['self'].GetExpiryDate();

          if (
            formData.ENDURING_MATERIAL.RELEASE_DATE != null &&
            formData.ENDURING_MATERIAL.RELEASE_DATE != ""
          ) {
            formData.ENDURING_MATERIAL.RELEASE_DATE = new Date(
              formData.ENDURING_MATERIAL.RELEASE_DATE
            );
        
          }
          if (
            formData.ENDURING_MATERIAL.EXPIRY_DATE != null &&
            formData.ENDURING_MATERIAL.EXPIRY_DATE != ""
          ) {
            formData.ENDURING_MATERIAL.EXPIRY_DATE = new Date(
              formData.ENDURING_MATERIAL.EXPIRY_DATE
            );
        
          }
          const ldate = new Date(formData.ENDURING_MATERIAL.RELEASE_DATE);
          formData.ENDURING_MATERIAL.RELEASE_DATE_STRING =
            ldate.getFullYear() +
            "-" +
            (ldate.getMonth() + 1) +
            "-" +
            ldate.getDate();

          const sdate = new Date(formData.ENDURING_MATERIAL.EXPIRY_DATE);
          formData.ENDURING_MATERIAL.EXPIRY_DATE_STRING =
            sdate.getFullYear() +
            "-" +
            (sdate.getMonth() + 1) +
            "-" +
            sdate.getDate();
        } else if (formData.FORMAT_TYPE_ID == "live") {


          formData["LIVE"]['START_DATEOBJ'] = this['self'].GetLiveStartDate();
          formData["LIVE"]['END_DATEOBJ'] = this['self'].GetLiveEndDate();

          formData.LIVE.NO_OF_FACULTIES = parseInt(
            formData.LIVE.NO_OF_FACULTIES
          );
          if (
            formData.LIVE.START_DATE != null &&
            formData.LIVE.START_DATE != ""
          ) {
            formData.LIVE.START_DATE = new Date(formData.LIVE.START_DATE);
          }
          if (formData.LIVE.END_DATE != null && formData.LIVE.END_DATE != "") {
            formData.LIVE.END_DATE = new Date(formData.LIVE.END_DATE);
          }

          const ldate = new Date(formData.LIVE.START_DATE);
          formData.LIVE.START_DATE_STRING =
            ldate.getFullYear() +
            "-" +
            (ldate.getMonth() + 1) +
            "-" +
            ldate.getDate();

          const sdate = new Date(formData.LIVE.END_DATE);
          formData.LIVE.END_DATE_STRING =
            sdate.getFullYear() +
            "-" +
            (sdate.getMonth() + 1) +
            "-" +
            sdate.getDate();
        } else if (formData.FORMAT_TYPE_ID == "web") {
          
          formData["WEB"]['START_DATEOBJ'] = this['self'].GetWebStartDate();
          formData["WEB"]['END_DATEOBJ'] = this['self'].GetWebEndDate();

          formData.WEB.NO_OF_FACULTIES = parseInt(formData.WEB.NO_OF_FACULTIES);
          if (
            formData.WEB.START_DATE != null &&
            formData.WEB.START_DATE != ""
          ) {
            formData.WEB.START_DATE = new Date(formData.WEB.START_DATE);
          
          }
          if (formData.WEB.END_DATE != null && formData.WEB.END_DATE != "") {
            formData.WEB.END_DATE = new Date(formData.WEB.END_DATE);

          }

          const ldate = new Date(formData.WEB.END_DATE);
          formData.WEB.END_DATE_STRING =
            ldate.getFullYear() +
            "-" +
            (ldate.getMonth() + 1) +
            "-" +
            ldate.getDate();

          const sdate = new Date(formData.WEB.START_DATE);
          formData.WEB.START_DATE_STRING =
            sdate.getFullYear() +
            "-" +
            (sdate.getMonth() + 1) +
            "-" +
            sdate.getDate();
        }
      } else {
        formData.LIVE = null;
        formData.WEB = null;
        formData.ENDURING_MATERIAL = null;
      }

      if(formData.ID == null || formData.ID == "" || formData.ID == undefined ) {
        //insert
        this['self'].summaryService.Insert('api/gmdeliveryformat/insertdeliveryformat', formData).subscribe((result) => {
          if (result.Status === 0) {
          
            this['self'].deliveryFormatForm.controls["ID"].setValue(result.TransactionID);
            this['self'].extendedForm.saveControls(result.TransactionID, result.Data, result.TransactionCode).subscribe(result1 => {
              if (result1.Status === 0) {
                this['self'].commonService.SuccessBanner(result.Message);
                this['self'].extendedForm.IsFormToched=false;
                this['self'].deliveryFormatForm.markAsPristine();
              }
              else {
                this['self'].commonService.ValidationBanner(result1.Message);
              }
            });
          }
          else{
            this['self'].commonService.ValidationBanner(result.Message);
          }

        });
      }
      else {
        //update
        this['self'].summaryService.Insert('api/gmdeliveryformat/insertdeliveryformat', formData).subscribe((summary) => {

          if (summary.Status === 0 || summary.ErrorCode === "NOCHANGES") {
            this['self'].extendedForm.saveControls(summary.TransactionID, summary.Data, summary.TransactionCode).subscribe(result => {
              if (result.ErrorCode === "NOCONTROLS") {
                if (summary.Status === 0)
                {
                  this['self'].commonService.SuccessBanner(summary.Message);
                  this['self'].extendedForm.IsFormToched=false;
                  this['self'].deliveryFormatForm.markAsPristine();
                }
                
                else {
                  this['self'].commonService.ValidationBanner(summary.Message);
                }
              }
              else {
                if (summary.ErrorCode === "NOCHANGES" && result.ErrorCode === "NOCHANGES") {
                  this['self'].commonService.ValidationBanner(summary.Message);
                } else {
                  if (this['self'].extendedForm != null && this['self'].extendedForm != undefined) {
                    this['self'].extendedForm.rowid = summary.TransactionID;
                    this['self'].extendedForm.getResponse();
                    this['self'].extendedForm.IsFormToched=false;
                    this['self'].deliveryFormatForm.markAsPristine();
                  }
                  this['self'].commonService.SuccessBanner('Delivery Format saved Successfully');
                }
              }
            });
          }
          else {
            this.commonService.ValidationBanner(summary.Message);
          }
        });
      }



    }
  }

  validateControls(): boolean {

    let isValid = true;
    let message = "";

    const formData = this.deliveryFormatForm.value;
    if (
      this.staticformFields?.THERAPEUTIC_AREA_ID.IS_Display &&
      this.staticformFields?.THERAPEUTIC_AREA_ID.IS_MANDATORY
    ) {
      if (
        formData.THERAPEUTIC_AREA_ID === null ||
        formData.THERAPEUTIC_AREA_ID === "" ||
        formData.THERAPEUTIC_AREA_ID === undefined
      ) {
        $("#THERAPEUTIC_AREA_ID").addClass(
          "ng-touched ng-invalid validate-error"
        );
        $("#THERAPEUTIC_AREA_ID").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.THERAPEUTIC_AREA_ID?.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#THERAPEUTIC_AREA_ID").addClass("ng-untouched ng-valid");
        $("#THERAPEUTIC_AREA_ID").removeClass(
          "ng-touched ng-invalid validate-error"
        );
      }
    }

    if (
      this.staticformFields?.FORMAT_TYPE_ID.IS_Display &&
      this.staticformFields?.FORMAT_TYPE_ID.IS_MANDATORY
    ) {
      if (
        formData.FORMAT_TYPE_ID === null ||
        formData.FORMAT_TYPE_ID === "" ||
        formData.FORMAT_TYPE_ID === undefined
      ) {
        $("#FORMAT_TYPE_ID").addClass("ng-touched ng-invalid validate-error");
        $("#FORMAT_TYPE_ID").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.FORMAT_TYPE_ID?.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#FORMAT_TYPE_ID").addClass("ng-untouched ng-valid");
        $("#FORMAT_TYPE_ID").removeClass(
          "ng-touched ng-invalid validate-error"
        );
      }
    }
    if (
      this.staticformFields?.MEETING_TYPE_ID.IS_Display &&
      this.staticformFields?.MEETING_TYPE_ID.IS_MANDATORY
    ) {
      if (
        formData.MEETING_TYPE_ID === null ||
        formData.MEETING_TYPE_ID === "" ||
        formData.MEETING_TYPE_ID == 0 ||
        formData.MEETING_TYPE_ID === undefined
      ) {
        $("#MEETING_TYPE_ID").addClass("ng-touched ng-invalid validate-error");
        $("#MEETING_TYPE_ID").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.MEETING_TYPE_ID?.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#MEETING_TYPE_ID").addClass("ng-untouched ng-valid");
        $("#MEETING_TYPE_ID").removeClass(
          "ng-touched ng-invalid validate-error"
        );
      }
    }

    if (formData.FORMAT_TYPE_ID == "enduring_material") {
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var releasedate = new Date(formData.ENDURING_MATERIAL.RELEASE_DATE);
      var expirydate = new Date(formData.ENDURING_MATERIAL.EXPIRY_DATE);

      if (
        this.staticformFields?.IS_OPT_IN_PROCESS.IS_Display &&
        this.staticformFields?.IS_OPT_IN_PROCESS.IS_MANDATORY
      ) {
        if (
          formData.ENDURING_MATERIAL.IS_OPT_IN_PROCESS === null ||
          formData.ENDURING_MATERIAL.IS_OPT_IN_PROCESS === "" ||
          formData.ENDURING_MATERIAL.IS_OPT_IN_PROCESS === undefined
        ) {
          $("#IS_OPT_IN_PROCESS").addClass("ng-touched ng-invalid validate-error");
          $("#IS_OPT_IN_PROCESS").removeClass("ng-untouched ng-valid");
          message += `Please select ${this.staticformFields?.IS_OPT_IN_PROCESS?.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          $("#IS_OPT_IN_PROCESS").addClass("ng-untouched ng-valid");
          $("#IS_OPT_IN_PROCESS").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      if (
        this.staticformFields?.RELEASE_DATE.IS_Display &&
        this.staticformFields?.RELEASE_DATE.IS_MANDATORY
      ) {
        if (
          formData.ENDURING_MATERIAL.RELEASE_DATE === null ||
          formData.ENDURING_MATERIAL.RELEASE_DATE === "" ||
          formData.ENDURING_MATERIAL.RELEASE_DATE === undefined
        ) {
          $("#RELEASE_DATE").addClass("ng-touched ng-invalid validate-error");
          $("#RELEASE_DATE").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.RELEASE_DATE?.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          $("#RELEASE_DATE").addClass("ng-untouched ng-valid");
          $("#RELEASE_DATE").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      if (
        this.staticformFields?.EXPIRY_DATE.IS_Display &&
        this.staticformFields?.EXPIRY_DATE.IS_MANDATORY
      ) {
        if (
          formData.ENDURING_MATERIAL.EXPIRY_DATE === null ||
          formData.ENDURING_MATERIAL.EXPIRY_DATE === "" ||
          formData.ENDURING_MATERIAL.EXPIRY_DATE === undefined
        ) {
          $("#EXPIRY_DATE").addClass("ng-touched ng-invalid validate-error");
          $("#EXPIRY_DATE").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.EXPIRY_DATE?.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          $("#EXPIRY_DATE").addClass("ng-untouched ng-valid");
          $("#EXPIRY_DATE").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      if (
        formData.ENDURING_MATERIAL.EXPIRY_DATE != null &&
        expirydate < releasedate
      ) {
        $("#EXPIRY_DATE").addClass("ng-touched ng-invalid validate-error");
        $("#EXPIRY_DATE").removeClass("ng-untouched ng-valid");
        message += `${this.staticformFields?.EXPIRY_DATE?.LABEL_NAME} should be greater than ${this.staticformFields?.RELEASE_DATE?.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#EXPIRY_DATE").addClass("ng-untouched ng-valid");
        $("#EXPIRY_DATE").removeClass("ng-touched ng-invalid validate-error");
      }

      if (
        this.staticformFields?.TRANSFER_MODE.IS_Display &&
        this.staticformFields?.TRANSFER_MODE.IS_MANDATORY
      ) {
        if (
          formData.ENDURING_MATERIAL.TRANSFER_MODE === null ||
          formData.ENDURING_MATERIAL.TRANSFER_MODE === "" ||
          formData.ENDURING_MATERIAL.TRANSFER_MODE === undefined
        ) {
          $("#TRANSFER_MODE").addClass("ng-touched ng-invalid validate-error");
          $("#TRANSFER_MODE").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.TRANSFER_MODE?.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          $("#TRANSFER_MODE").addClass("ng-untouched ng-valid");
          $("#TRANSFER_MODE").removeClass(
            "ng-touched ng-invalid validate-error"
          );
        }
      }

      formData.LIVE = null;
      formData.WEB = null;
    }

    if (formData.FORMAT_TYPE_ID == "live") {
      if (
        this.staticformFields?.LIVE_FACULTIES_CNT.IS_Display &&
        this.staticformFields?.LIVE_FACULTIES_CNT.IS_MANDATORY
      ) {
        if (
          formData.LIVE.NO_OF_FACULTIES === null ||
          formData.LIVE.NO_OF_FACULTIES === "" ||
          formData.LIVE.NO_OF_FACULTIES === undefined
        ) {
          $("#NO_OF_FACULTIES").addClass(
            "ng-touched ng-invalid validate-error"
          );
          $("#NO_OF_FACULTIES").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.LIVE_FACULTIES_CNT?.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          $("#NO_OF_FACULTIES").addClass("ng-untouched ng-valid");
          $("#NO_OF_FACULTIES").removeClass(
            "ng-touched ng-invalid validate-error"
          );
        }

        if (formData.LIVE.NO_OF_FACULTIES == 0) {
          message += `Please enter ${this.staticformFields?.LIVE_FACULTIES_CNT?.LABEL_NAME} greater than zero<br/>`;
          isValid = false;
        }
      }
      if (
        this.staticformFields?.LIVE_START_DATE.IS_Display &&
        this.staticformFields?.LIVE_START_DATE.IS_MANDATORY
      ) {
        if (
          formData.LIVE.START_DATE === null ||
          formData.LIVE.START_DATE === "" ||
          formData.LIVE.START_DATE === undefined
        ) {
          $("#START_DATE").addClass("ng-touched ng-invalid validate-error");
          $("#START_DATE").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.LIVE_START_DATE?.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          $("#START_DATE").addClass("ng-untouched ng-valid");
          $("#START_DATE").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      if (
        this.staticformFields?.LIVE_END_DATE.IS_Display &&
        this.staticformFields?.LIVE_END_DATE.IS_MANDATORY
      ) {
        if (
          formData.LIVE.END_DATE === null ||
          formData.LIVE.END_DATE === "" ||
          formData.LIVE.END_DATE === undefined
        ) {
          $("#END_DATE").addClass("ng-touched ng-invalid validate-error");
          $("#END_DATE").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.LIVE_END_DATE?.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          $("#END_DATE").addClass("ng-untouched ng-valid");
          $("#END_DATE").removeClass("ng-touched ng-invalid validate-error");
        }
      }

      // var today = new Date();
      // today.setHours(0, 0, 0, 0);

      var startdate = new Date(formData.LIVE.START_DATE);
      var enddate = new Date(formData.LIVE.END_DATE);

      if (
        formData.LIVE.END_DATE != null ||
        formData.LIVE.END_DATE != "" ||
        formData.LIVE.END_DATE != undefined
      )
        if (startdate > enddate) {
          $("#START_DATE").addClass("ng-touched ng-invalid validate-error");
          $("#START_DATE").removeClass("ng-untouched ng-valid");
          //message += `The ${this.staticformFields?.LIVE_END_DATE?.LABEL_NAME} should be greater than ${this.staticformFields?.LIVE_START_DATE?.LABEL_NAME}<br/>`;
          message = message + `${this.staticformFields?.LIVE_END_DATE?.LABEL_NAME} cannot be lesser than  ${this.staticformFields?.LIVE_START_DATE?.LABEL_NAME} Please update the details </br>`;
          isValid = false;
        } else {
          $("#START_DATE").addClass("ng-untouched ng-valid");
          $("#START_DATE").removeClass("ng-touched ng-invalid validate-error");
        }

      if (
        this.staticformFields?.LIVE_ADDRESS.IS_Display &&
        this.staticformFields?.LIVE_ADDRESS.IS_MANDATORY
      ) {
        if (
          formData.LIVE.ADDRESS === null ||
          formData.LIVE.ADDRESS === "" ||
          formData.LIVE.ADDRESS === undefined
        ) {
          $("#ADDRESS").addClass("ng-touched ng-invalid validate-error");
          $("#ADDRESS").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.LIVE_ADDRESS?.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          $("#ADDRESS").addClass("ng-untouched ng-valid");
          $("#ADDRESS").removeClass("ng-touched ng-invalid validate-error");
        }
      }
      formData.WEB = null;
      formData.ENDURING_MATERIAL = null;
    }

    if (formData.FORMAT_TYPE_ID == "web") {
      formData.LIVE = null;
      formData.ENDURING_MATERIAL = null;
      if (
        this.staticformFields?.WEB_FACULTIES_CNT.IS_Display &&
        this.staticformFields?.WEB_FACULTIES_CNT.IS_MANDATORY
      ) {
        if (formData.WEB.NO_OF_FACULTIES === null || formData.WEB.NO_OF_FACULTIES === "" || formData.WEB.NO_OF_FACULTIES === undefined)
         {
          $("#NO_OF_FACULTIES").addClass(
            "ng-touched ng-invalid validate-error"
          );
          $("#NO_OF_FACULTIES").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.WEB_FACULTIES_CNT?.LABEL_NAME}<br/>`;
          isValid = false;
        } 
        else 
        {
          $("#NO_OF_FACULTIES").addClass("ng-untouched ng-valid");
          $("#NO_OF_FACULTIES").removeClass(
            "ng-touched ng-invalid validate-error"
          );
        }
        if(formData.WEB.NO_OF_FACULTIES == 0)
        {
          message += `Please enter ${this.staticformFields?.WEB_FACULTIES_CNT?.LABEL_NAME} greater than zero<br/>`;
          isValid = false;
        }
         
      }
    

      var startdate = new Date(formData.WEB.START_DATE);
      var enddate = new Date(formData.WEB.END_DATE);

      if (
        this.staticformFields?.WEB_START_DATE.IS_Display &&
        this.staticformFields?.WEB_START_DATE.IS_MANDATORY
      ) {
        if (
          formData.WEB.START_DATE === null ||
          formData.WEB.START_DATE === "" ||
          formData.WEB.START_DATE === undefined
        ) {
          $("#START_DATE").addClass("ng-touched ng-invalid validate-error");
          $("#START_DATE").removeClass("ng-untouched ng-valid");
          message += `Please select ${this.staticformFields?.WEB_START_DATE?.LABEL_NAME} <br/>`;
          isValid = false;
        } else {
          $("#START_DATE").addClass("ng-untouched ng-valid");
          $("#START_DATE").removeClass("ng-touched ng-invalid validate-error");
        }
      }
      if (
        this.staticformFields?.WEB_END_DATE.IS_Display &&
        this.staticformFields?.WEB_END_DATE.IS_MANDATORY
      ) {
        if (
          formData.WEB.END_DATE === null ||
          formData.WEB.END_DATE === "" ||
          formData.WEB.END_DATE === undefined
        ) {
          $("#END_DATE").addClass("ng-touched ng-invalid validate-error");
          $("#END_DATE").removeClass("ng-untouched ng-valid");
          message += `Please select ${this.staticformFields?.WEB_END_DATE?.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          $("#END_DATE").addClass("ng-untouched ng-valid");
          $("#END_DATE").removeClass("ng-touched ng-invalid validate-error");
        }
      }
      if (
        formData.WEB.WebEndDate != null ||
        formData.WEB.WebEndDate != "" ||
        formData.WEB.WebEndDate != undefined
      ) {
        if(formData.WEB.END_DATE!=null){
        if (startdate > enddate) {
          $("#START_DATE").addClass("ng-touched ng-invalid validate-error");
          $("#START_DATE").removeClass("ng-untouched ng-valid");
          message = message + `${this.staticformFields?.WEB_START_DATE?.LABEL_NAME} cannot be lesser than  ${this.staticformFields?.WEB_END_DATE?.LABEL_NAME} Please update the details </br>`;
          // message +=
          //   `Please select ${this.staticformFields?.WEB_START_DATE?.LABEL_NAME} less than or equal to ${this.staticformFields?.WEB_END_DATE?.LABEL_NAME}<br/>`;
          isValid = false;
        } else {
          $("#START_DATE").addClass("ng-untouched ng-valid");
          $("#START_DATE").removeClass("ng-touched ng-invalid validate-error");
        }
      }
      }

      if (
        this.staticformFields?.WEB_URL.IS_Display &&
        this.staticformFields?.WEB_URL.IS_MANDATORY
      ) {
        if (
          formData.WEB.WEB_URL === null ||
          formData.WEB.WEB_URL === "" ||
          formData.WEB.WEB_URL === undefined
        ) {
          $("#WEB_URL").addClass("ng-touched ng-invalid validate-error");
          $("#WEB_URL").removeClass("ng-untouched ng-valid");
          message += `Please enter ${this.staticformFields?.WEB_URL?.LABEL_NAME}<br/>`;
          isValid = false;
        }
        else {
          const siteformat =
            /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
          //const mailformat = /^w+([.-]?w+)*@w+([.-]?w+)*(.w{2,3})+$/;
          if (formData.WEB.WEB_URL.match(siteformat)) {
            $("#WEB_URL").addClass("ng-untouched ng-valid");
            $("#WEB_URL").removeClass("ng-touched ng-invalid validate-error");
          } else {
            $("#WEB_URL").addClass("ng-touched ng-invalid validate-error");
            $("#WEB_URL").removeClass("ng-untouched ng-valid");
            message += `Please enter ${this.staticformFields?.WEB_URL?.LABEL_NAME}<br/>`;
            isValid = false;
          }
        }
      }

    }
    

    let ExtenMsgs = this.extendedForm.validateControlsMsgs();
    if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
      isValid = false;
      message = message + ExtenMsgs;
    }

    if (!isValid) {
      this.commonService.ValidationBanner(message);
    }
    return isValid;
  }

  validateDelControls(): boolean {
    let isValid = true;
    let message = "";
    var formData = this["self"].deliveryFormatForm.value;

    if (
      formData.THERAPEUTIC_AREA_ID === null ||
      formData.THERAPEUTIC_AREA_ID === "" ||
      formData.THERAPEUTIC_AREA_ID === undefined
    ) {
      $("#THERAPEUTIC_AREA_ID").addClass(
        "ng-touched ng-invalid validate-error"
      );
      $("#THERAPEUTIC_AREA_ID").removeClass("ng-untouched ng-valid");
      message += "Please enter Therapeutic Area<br/>";
      isValid = false;
    } else {
      $("#THERAPEUTIC_AREA_ID").addClass("ng-untouched ng-valid");
      $("#THERAPEUTIC_AREA_ID").removeClass(
        "ng-touched ng-invalid validate-error"
      );
    }

    if (
      formData.FORMAT_TYPE_ID === null ||
      formData.FORMAT_TYPE_ID === "" ||
      formData.FORMAT_TYPE_ID === undefined
    ) {
      $("#FORMAT_TYPE_ID").addClass("ng-touched ng-invalid validate-error");
      $("#FORMAT_TYPE_ID").removeClass("ng-untouched ng-valid");
      message += "Please enter Delivery Format Type<br/>";
      isValid = false;
    } else {
      $("#FORMAT_TYPE_ID").addClass("ng-untouched ng-valid");
      $("#FORMAT_TYPE_ID").removeClass("ng-touched ng-invalid validate-error");
    }

    if (!isValid)
      //  this.modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: message } } });
      return isValid;
  }

  NavigateToGenInfo() {
    this.appid = this.commonService.appId;
    let MenuModule = this.commonService.getModuleMenu();
    if (this.appid == null || this.appid == undefined || this.appid == "") {
      const modalRefAcc = this.modalService.open(MessageBoxComponent, {});
      modalRefAcc.componentInstance.Content = {
        heading: "",
        content: {
          heading: "",
          description:
            "Please save General information details to navigate to Delivery Format",
          operation: { hasConfirm: false },
        },
      };
      modalRefAcc.result.then((result) => {
        this.router.navigate(
          [
            "/home/grants/my-applications/application-ext/:" +
            0 +
            "/geninfocme",
          ],
          {
            skipLocationChange: true,
            queryParams: {
              id: 0,
              app_ext: true,
              module: "grants",
              submodule: MenuModule.module,
              screen_type: "my-applications",
            },
          }
        );
      });
      return false;
    }
  }
  canExit() {
    if (this.deliveryFormatForm.dirty || this.extendedForm.IsFormToched) {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }
}
